import SjQuestionFile from './src/SjQuestionFile.vue'

export default SjQuestionFile



// WEBPACK FOOTER //
// ./src/views/question-editor/packages/sj-question-file/index.js